import React, { Component } from 'react';
import $ from 'jquery'

import yuassist from './../assests/images/projects/yu-assist.jpg';
import webpage from './../assests/images/projects/webpage.png';
import bookstore from './../assests/images/projects/bookstore.jpg';
import bankaccount from './../assests/images/projects/bank-account.png';

import networks from './../assests/images/projects/networks.jpg';
import ddos from './../assests/images/projects/ddos.jpg';
import exam from './../assests/images/projects/exam.jpg';

import curve from './../assests/images/projects/learner.jpg';
import sentiment from './../assests/images/projects/sentiment.jpg';

function ProjectItem(props) 
{
	const technologies = props.t.map(function(t, i){
		return <span className="tag is-medium">{t}</span>
	})
  return <div className="media animated fadeIn delay-800ms">
					{/* <div className="media-left is-hidden-mobile padding-one-top">
						<img class="ui centered tiny image" src={props.image}/>
					</div> */}
					<div className="media-content">
						<p className="title has-text-weight-bold is-size-5-mobile is-size-4-tablet padding-one-bottom">{props.name}</p>
						<p className="subtitle has-text-weight-light is-size-6-mobile is-size-5-tablet">{props.description}</p>
						<div className="tags is-normal-mobile is-normal-tablet">
							{technologies}
						</div>
						<div className="container">
							<a href={props.link} class="button is-dark is-outlined">
								<span class="icon">
									<i class="fab fa-github"></i>
								</span>
								<span>GitHub</span>
							</a>
						</div>
					</div>
				</div>
}

function AllItems(props) {
	var projects = props.projects
	var filter = props.filter 
	return projects.map(function(p) {
		if(filter === 'all' || filter === p.tag)
		{
			return <ProjectItem name={p.projectName} t={p.technologies} description={p.description} image={p.image} link={p.link}/>
		}
	})
}

class AllProjects extends Component {
	constructor(){
		super();
		const projectItems = [
			{
					projectName: 'YU-Assist',
					description: 'An app on the google assistant to help York University students find information like GPA, courses enrolled quickly using voice-recognition.',
					technologies: ['Firebase', 'NodeJS', 'DialogFlow'],
					link: 'https://github.com/akshayrpatel/YU-Assist',
					tag: 'personal',
					image: yuassist
			},
			{
					projectName: 'Web-page Classification',
					description: 'Built a classification learning model for text classification of web pages using SVM (Support Vector Machines) with 10-fold cross validation, into categories ‘student’, ‘faculty’, or ‘course’.',
					technologies: ['Python', 'Weka'],
					link: 'https://github.com/akshayrpatel/Web-Page-Classification',
					tag: 'machine-learning',
					image: webpage
			},
			{
					projectName: 'Bookstore',
					description: 'A simple bookstore application that allows clients to browse the bookstore, create an account, view book details, write a review, add books to cart, view cart items, and checkout using a valid credit card.',
					technologies: ['JSPX', 'XML', 'Java EE', 'Apache Derby', 'Apache Tomcat', 'Apache Axis', 'SOAP', 'Jersey'],
					link: 'https://github.com/azkevin/Bookstore',
					tag: 'software',
					image: bookstore
			},
			{
					projectName: 'Polynomial Curve Fitting',
					description: 'Modeled a polynomial regression vector over a dataset using ERM (Empirical Risk Minimization) and RLM (Regularized Loss Minimization) and compared the two weight vectors using a graph to show the scenario of overfitting while training a learner in ML.',
					technologies: ['MATLAB'],
					link: 'https://github.com/akshayrpatel/Machine-Learning',
					tag: 'machine-learning',
					image: curve
			},
			{
					projectName: 'Analyzer (Design by Contract)',
					description: 'An expression language analyzer application that performs operations like ‘AND’, ‘OR’, ‘ADD’, ‘SUBTRACT’, ‘JOIN’, ‘INTERSECT’ etc. on a given mathematical expression. Implemented an abstract UI by hiding the details of classes and features of the underlying software. Implemented contracts and wrote violation tests to make sure the software obeys design principles like information hiding, single-choice, open-close & uniform access.',
					technologies: ['Eiffel', 'ESpec Unit Testing'],
					link: '',
					tag: 'software',
					image: ''
			},
			{
					projectName: 'Bank Account (Design by Contract)',
					description: 'A bank application that allows clients to create an account, deposit & withdraw money from an existing account. Implemented contracts and wrote violation tests to make sure the software obeys design principles like information hiding and uniform access.',
					technologies: ['Eiffel', 'ESpec Unit Testing'],
					link: '',
					tag: 'software',
					image: bankaccount
			},
			{
					projectName: 'Client-Server Communication',
					description: 'A simple java application that allows clients to send messages to and receive message from a server.',
					technologies: ['Java', 'Socket I/O'],
					link: '',
					tag: 'networks',
					image: networks
			},
			{
					projectName: 'DDoS Attack Simulator',
					description: 'A java application that simulates a DDoS attack',
					technologies: ['Java', 'Multi-threading', 'Socket I/O'],
					link: '',
					tag: 'networks',
					image: ddos
			},
			{
					projectName: 'Exam Application',
					description: 'An application that simulates functionalities of an online in-class test.',
					technologies: ['Java', 'Multi-threading', 'Socket I/O'],
					link: '',
					tag: 'networks',
					image: exam
			},
			{
					projectName: 'Twitter Sentiment Analysis',
					description: 'Real time sentiment analysis of top trending topics on Twitter',
					technologies: ['Python', 'Apache Spark', 'Flask'],
					link: '',
					tag: 'big-data',
					image: sentiment
			},
			{
					projectName: 'Text Generation',
					description: 'A Recurrent Neural Network that learns character-by-character on some text and generates new text.',
					technologies: ['PyTorch', 'Jupyter Notebook'],
					link: '',
					tag: 'machine-learning',
					image: sentiment
			},
			{
					projectName: 'Style Transfer',
					description: 'A Convolutional Neural Network that given two images, a style and a content image, creates a new image with objects and arrangements of the content image whereas style, colors and textures of the style image',
					technologies: ['PyTorch', 'Jupyter Notebook'],
					link: '',
					tag: 'machine-learning',
					image: sentiment
			}
		]
		const filter = 'all'

		this.state = {
			projects: projectItems,
			filter: filter
		} 

		this.handleOnClick = this.handleOnClick.bind(this)
		this.handleDropdown = this.handleDropdown.bind(this)
		this.handleBackClick = this.handleBackClick.bind(this)
	}

	handleBackClick() {
		this.props.history.push('/')
	}

	handleOnClick(target){
		$('.is-active').removeClass('is-active');
		$(target).parent().addClass('is-active');
		this.setState({
			filter: target.getAttribute('name')
		})
	}

	handleDropdown(event){
		// console.log(event.target.value)
		this.setState({
			filter: event.target.value
		})
	}

	componentDidMount() {
		var el = document.getElementById('projects_header_title')
		el.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
	}

	render() {
		const options = ['All', 'Computer Networks', 'Software Design', 'Big Data', 'Machine Learning', 'Cryptography', 'Personal', 'Hackathon', 'Coding Questions']
		const values = ['all', 'networks', 'software', 'big-data', 'machine-learning', 'cryptography', 'personal', 'hackathon', 'coding']

		const listItems = values.map(function(item, index) {
			if(item === 'all')
				return <li className="is-active"><a name={item}>{options[index]}</a></li>
			else
				return <li><a name={item}>{options[index]}</a></li>
		})

		const dropdownItems = values.map(function(item, index){
				if(item === 'all')
					return <option className="is-active" value={item}>{options[index]}</option>
				else
					return <option value={item}>{options[index]}</option>
			})

		return (
			<div id="all_projects" className="is-bold animated fadeIn delay-800ms">

				{/* <div className="column padding-two-top">
					<a class="button has-text-left" onClick={(e) => this.handleBackClick(e.target)}><i className="fas fa-chevron-left fa-lg"></i></a>
				</div> */}
        <div id="projects_header_title" className="column has-text-centered">
					<a class="button is-dark is-outlined is-pulled-left" onClick={(e) => this.handleBackClick(e.target)}><i className="fas fa-chevron-left fa-lg"></i></a>
					<p className="title is-5 is-blue has-text-bold padding-two-top">PROJECTS <span class="tag is-dark is-normal">Working on it!</span></p>
				</div>

        <div className="column is-hidden-touch has-text-centered">
          <div className="tabs is-centered has-text-white is-small-mobile">
            <ul onClick={(e) => this.handleOnClick(e.target)}>
              {/* <li className="is-active"><a name="all" onClick={(e) => this.handleOnClick(e.target)}>All</a></li>
              <li><a name="networks" onClick={(e) => this.handleOnClick(e.target)}>Computer Networks</a></li>
              <li><a name="software" onClick={(e) => this.handleOnClick(e.target)}>Software Design</a></li>
              <li><a name="big-data" onClick={(e) => this.handleOnClick(e.target)}>Big Data</a></li>
              <li><a name="machine-learning" onClick={(e) => this.handleOnClick(e.target)}>Machine Learning</a></li>
              <li><a name="personal" onClick={(e) => this.handleOnClick(e.target)}>Personal</a></li>
							<li><a name="hackathon" onClick={(e) => this.handleOnClick(e.target)}>Hackathons</a></li> */}
							{listItems}
            </ul>
          </div>
        </div>

				<div className="column is-hidden-desktop">
					<div class="field">
						<div class="control has-icons-left">
							<div class="select">
								<select onChange={this.handleDropdown}>
									{dropdownItems}
								</select>
							</div>
							<div class="icon is-small is-left">
								<i class="fas fa-drafting-compass"></i>
							</div>
						</div>
					</div>
					{/* <div class="select">
						<select>
							{dropdownItems}
						</select>
					</div> */}
				</div>

				<div className="container">
					<div className="column">
						<AllItems projects={this.state.projects} filter={this.state.filter}/>
					</div>
				</div>
			</div>
		);
	}
}

export default AllProjects;